import { render, staticRenderFns } from "./Symbols.vue?vue&type=template&id=589a5611"
import script from "./Symbols.vue?vue&type=script&lang=js"
export * from "./Symbols.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports